<template>
  <template v-if="model.showContent">
    <div class="web-container">
      <HeaderBar />
      <div class="banner-bar">
        <div class="carousel-bar" :style="`opacity: ${model.carousels[model.activeCarouselIndex].show ? '1' : '0'};`">
          <div class="carousel-content">
            <div class="cc-title">{{ model.carousels[model.activeCarouselIndex].title }}</div>
            <div class="cc-brief" v-html="model.carousels[model.activeCarouselIndex].brief"></div>
            <div class="cc-content">{{ model.carousels[model.activeCarouselIndex].content }}</div>
            <div class="cc-btn" @click="routerClick(model.carousels[model.activeCarouselIndex].router)">立即咨询</div>
          </div>
          <img :src="require(`@/assets/home/${model.carousels[model.activeCarouselIndex].key}.png`)" />
        </div>
        <div class="carousel-bg"
          :style="`background: linear-gradient(180deg, ${model.carousels[model.activeCarouselIndex].startColor} 0%, ${model.carousels[model.activeCarouselIndex].endColor} 100%);`">
          <img :src="require(`@/assets/home/${model.carousels[model.activeCarouselIndex].key}-bg.png`)" />
        </div>
        <div class="carousel-select">
          <div v-for="item in model.carousels" :key="item.key" class="carousel-select-btn"
            :style="`${item.index === model.activeCarouselIndex ? 'background:#3379F1' : ''}`"
            @click="handleCarousel(item)">
          </div>
        </div>
        <div class="menu-bar">
          <div v-for="item in model.menus" :key="item.key" class="menu-btn" @mouseover="menuHover(item)"
            @mouseout="menuLeave(item)" @click="routerClick(item.router)">
            <img :src="require(`@/assets/home/menu-${item.key}${item.active ? '-active' : ''}.png`)" />
            <div class="menu-label" :style="`color:${item.active ? '#3379F1' : '#333'}`">{{ item.label }}</div>
          </div>
        </div>
        <div class="bonus-bar">
          <div class="bonus-title">
            <img :src="require(`@/assets/home/bonus-title.png`)" />
          </div>
          <div v-for="item in model.bonusTopics" :key="item.key" class="bonus-topic"
            :style="`${item.active ? 'background:#E1EBFD' : ''}`" @mouseover="handleBonusHover(item)"
            @mouseout="handleBounsLeave(item)">
            <div class="topic-title">{{ item.topic }}</div>
            <div class="topic-label">{{ item.label }}</div>
          </div>
        </div>
        <div class="bonus-detail" v-if="model.bonusShowDetail.show" @mouseover="handleBonusDetail"
          @mouseout="handleBounsLeave(null)">
          <div class="bd-title">
            <div class="bd-topic">{{ model.bonusShowDetail.bonusInfo.topic }}</div>
            <div class="bd-label">{{ model.bonusShowDetail.bonusInfo.label }}</div>
          </div>
          <div class="bd-content">
            <div v-for="item in model.bonusShowDetail.contents" :key="item.contentSn">
              <div v-if="item.contentType === '1'" class="content-content" v-html="item.content"></div>
            </div>
          </div>
        </div>
        <div class="data-bar">
          <div v-for="item in model.dataMenus" :key="item.key" class="data-card"
            @click="routerClick(item.router)">
            <img :src="require(`@/assets/home/data-${item.key}.png`)" />
            <div class="data-label">
              <div>{{ item.label }}</div>
              <div style="font-size: 14px;margin-top: 5px;color: #666;">{{ item.brief }}</div>
            </div>
            <div class="data-card-mask"></div>
          </div>
        </div>
      </div>
      <div class="strategy-bar">
        <div class="strategy-title">AI云量化策略集</div>
        <div class="strategy-brief">收录多品种不同策略逻辑的策略</div>
        <div class="strategy-cards">
          <div class="strategy-card" v-for="item in model.strategyCards" :key="item.key"
            @click="routerClick(item.router)">
            <img :src="require(`@/assets/home/${item.key}.png`)" />
            <div class="info-bar">
              <div class="strategy-info">
                <div class="info-title">{{ item.label }}</div>
                <div class="info-brief">{{ item.brief }}</div>
              </div>
              <div class="strategy-btn">查看</div>
            </div>
          </div>
        </div>
      </div>
      <div class="vip-bar">
        <div class="vip-title">VIP策略库</div>
        <div class="vip-brief">此部分仅提供给机构客户</div>
        <div class="vip-cards">
          <div class="direction-cards">
            <img :src="require(`@/assets/home/vip-left.png`)" @click="handleNextVipCard" />
          </div>

          <template v-for="item in model.vipCards" :key="item.key">
            <div :style="`opacity: ${item.show ? '1' : '0'};`" :class="`${item.active ? 'vip-card-active' : ''}`"
              class="vip-card" @mouseover="handleCardOver(item)" @click="handleVipClick(item)">
              <div class="vip-card-label">{{ item.label }}</div>
              <div class="vip-card-brief" v-if="!item.active">{{ item.brief }}</div>
              <img :src="require(`@/assets/home/${item.img}${item.active ? '-active' : ''}.png`)" class="vip-bg" />
              <div class="vip-detail-bar" v-if="item.active">
                <div v-for="detail in item.details" :key="detail.key" class="vip-detail">
                  <img :src="require(`@/assets/home/vip-arrow.png`)" />
                  <div class="vip-detail-label">{{ detail.label }}:{{ detail.content }}</div>
                </div>
              </div>
              <div class="vip-card-btn" v-if="item.active" >机构合作请联系客服</div>
              <div class="vip-card-mask" v-if="!item.active"
                :style="`background: linear-gradient(${item.colorGradient} 24%, ${item.colorGradient}05 70%)`"></div>
              <div class="vip-card-mask" v-if="item.active"
                :style="`background: linear-gradient(${item.colorGradientActive} 24%, ${item.colorGradientActive}88 70%)`">
              </div>
            </div>
          </template>
          <div class="direction-cards">
            <img :src="require(`@/assets/home/vip-right.png`)" @click="handlePreviousVipCard" />
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
    <CustomerService />
    <LoginIndex />
  </template>
</template>
  
<script setup>
import HeaderBar from "@/views/web/components/header-bar.vue";
import BottomBar from "@/views/web/components/bottom-bar.vue";
import CustomerService from "@/views/web/components/customer-service.vue";
import "@/assets/font/font.css";
import { reactive, onDeactivated, getCurrentInstance, nextTick, onBeforeMount } from "vue";
import LoginIndex from "@/views/web/login/login-index.vue";
import { useRouter } from "vue-router";
import Prism from "prismjs";
import "prismjs/components/prism-python.min.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/themes/prism.css";
const post = getCurrentInstance().appContext.config.globalProperties.post;
const router = useRouter();
const model = reactive({
  //是否展示
  showContent: false,
  //轮播图
  carousels: [
    // { key: "carousel1", index: 0, title: "0元闯关", brief: "零门槛学习Python和量化", content: "免费闯关赢大奖！名额有限欢迎挑战！", show: true, startColor: "#E6F8FF", endColor: "#C0D8FD", router: "customerService" },
    { key: "carousel1", index: 0, title: "全国大学生量化交易大赛", brief: "● 凡对量化交易感兴趣的均可免费报名参赛<br/>● 不懂代码编写的选手可参加基金经理大赛<br/>● 懂代码编写策略的选手可参加策略研究员大赛", content: "", show: true, startColor: "#E6FDFF", endColor: "#C0E2FD", router: "customerService" },
    // { key: "carousel2", index: 1, title: "一对一指导，零基础入门", brief: "30天掌握Python量化交易技能", content: "一对一指导，快速入门", show: false, startColor: "#E6FDFF", endColor: "#C0E2FD", router: "customerService" },
  ],
  carouselTimer: null,
  activeCarouselIndex: 0,
  //菜单
  menus: [
    { key: "python", active: false, label: "Python入门", router: "class/python", check: false },
    { key: "quantify", active: false, label: "量化基础", router: "class/quantify", check: false },
    { key: "strategy", active: false, label: "策略研习", router: "strategy/strategy", check: false },
    { key: "software", active: false, label: "易宽实盘交易", router: "class/software", check: true },
    { key: "system", active: false, label: "交易系统开发", router: "class/softwareDevelop", check: true },
    { key: "job", active: false, label: "实习与就业", router: "job", check: false },
  ],
  //奖学金
  bonusTopics: [],
  bonusShowDetail: {
    show: false,
    bonusInfo: { key: "", topic: "", label: "", contents: [] },
  },
  bonusClearTask: null,
  //数据模块
  dataMenus: [
    { key: "exam", label: "考证题库", brief: '基金、证券、期货', active: false, router: "class/exam", check: true },  //股票数据
    { key: "math", label: "数学与机器学习", brief: "PyTorch、TensorFlow", active: false, router: "class/math", check: true },  //期货数据
    { key: "system", label: "分布式系统", brief: "Linux、HDFS、Docker ", active: false, router: "class/system", check: true }, //期权数据
    { key: "programming", label: "计算机语言", brief: "C++、MATLAB、R", active: false, router: "class/programming", check: true }, //指数数据
    { key: "database", label: "数据库", brief: "MySQL、MongoDB、Redis", active: false, router: "class/database", check: true }, //基金数据
    { key: "pyquantGame", label: "量化竞赛指导", brief: "worldquant、kaggle", active: false, router: "class/pyquantGame", check: true }, //其他数据
  ],
  //策略
  strategyCards: [
    { key: "strategy-stock", label: "股票策略", brief: "长期投资，短期投机", router: "strategy/strategyStock", check: true },
    { key: "strategy-etf", label: "ETF策略", brief: "指数增强，动量轮动", router: "strategy/strategyEtf", check: true },
    { key: "strategy-futures", label: "期货策略", brief: "趋势跟随，期现套利", router: "strategy/strategyFutures", check: true },
    { key: "strategy-options", label: "期权策略", brief: "利用期权，套利投机", router: "strategy/strategyOptions", check: true },
    { key: "strategy-cb", label: "可转债策略", brief: "股债联动，双低套利", router: "strategy/strategyCb", check: true },
    { key: "strategy-fof", label: "FOF策略", brief: "基金组合，分散风险", router: "strategy/strategyFof", check: true },
    { key: "strategy-ai", label: "机器学习策略", brief: "科学预测，智能择时", router: "strategy/strategyAi", check: true },
    { key: "strategy-frequency", label: "高频策略", brief: "统计套利，事件驱动", router: "strategy/strategyFrequency", check: true },
  ],
  //vip
  vipCards: [
    {
      key: "vip-stock",
      img: "vip-stock",
      colorGradient: "#B0EDFF",
      colorGradientActive: "#E8F5FF",
      label: "股票策略",
      brief: "长期投资，短期投机",
      active: true,
      show: true,
      router: "class/vipStock",
      details: [
        { key: "d11", label: "多因子股票策略", content: "选取多种因子进行综合分析，寻找超额收益选" },
        { key: "d12", label: "因子集成股票策略", content: "将多种因子策略进行组合，提高收益稳定性" },
        { key: "d13", label: "择时股票策略", content: "根据市场趋势进行买卖，获取择时收益" },
        { key: "d14", label: "价值成长策略", content: "根据价值或成长因子进行选股，获取超额收益" },
        { key: "d15", label: "动量跟随策略", content: "根据股价动量进行买卖，获取趋势收益" },
      ],
    },
    {
      key: "vip-etf",
      img: "vip-etf",
      colorGradient: "#B0EDFF",
      colorGradientActive: "#DDF7FF",
      label: "ETF策略",
      brief: "指数增强，动量轮动",
      active: false,
      show: true,
      router: "class/vipEtf",
      details: [
        { key: "d21", label: "ETF配对策略", content: "利用ETF的价差进行套利" },
        { key: "d22", label: "ETF集成delta中性策略", content: "构建delta中性组合，降低波动率" },
        { key: "d23", label: "指数增强策略", content: "利用ETF进行指数增强组合" },
        { key: "d24", label: "ETF动量轮动策略", content: "根据ETF的动量进行轮动" },
        { key: "d25", label: "ETF定投策略", content: "定期定额投资ETF，降低风险" },
      ],
    },
    {
      key: "vip-futures",
      img: "vip-futures",
      colorGradient: "#C7DDFF",
      colorGradientActive: "#E6F0FF",
      label: "期货策略",
      brief: "趋势跟随，期现套利",
      active: false,
      show: true,
      router: "class/vipFutures",
      details: [
        { key: "d31", label: "期货T0策略", content: "利用期货的T+0交易特性进行套利" },
        { key: "d32", label: "均值回归策略", content: "利用期货价格的均值回归特性进行套利" },
        { key: "d33", label: "特征收敛策略", content: "利用期货价格的特征收敛特性进行套利" },
        { key: "d34", label: "期货跨期套利策略", content: "利用期货合约之间的价差进行套利" },
        { key: "d35", label: "期货趋势跟随策略", content: "利用期货价格的趋势进行交易" },
      ],
    },
    {
      key: "vip-options",
      img: "vip-options",
      colorGradient: "#ADE8FF",
      colorGradientActive: "#DAF4FF",
      label: "期权策略",
      brief: "利用期权，套利投机",
      active: false,
      show: true,
      router: "class/vipOptions",
      details: [
        { key: "d41", label: "期权T0策略", content: "利用期权的T+0交易特性进行套利" },
        { key: "d42", label: "期权多空策略", content: "利用期权的多空特性进行交易" },
        { key: "d43", label: "期权日历套利策略", content: "利用期权合约之间的价差进行套利" },
        { key: "d44", label: "期权垂直价差策略", content: "利用期权合约的价格差异进行套利" },
        { key: "d45", label: "期权比率价差策略", content: "利用期权合约的比价差进行套利" },
      ],
    },
    {
      key: "vip-cb",
      img: "vip-cb",
      colorGradient: "#B0F4FF",
      colorGradientActive: "#E1FBFF",
      label: "可转债策略",
      brief: "股债联动，双低套利",
      active: false,
      show: true,
      router: "class/vipCb",
      details: [
        { key: "d51", label: "股债联动策略", content: "利用可转债与股票、债券之间的联动关系进行交易" },
        { key: "d52", label: "可转债双低策略", content: "利用可转债估值的低估机会进行交易" },
        { key: "d53", label: "可转债轮动策略", content: "根据可转债的估值、收益率等因素进行轮动" },
        { key: "d54", label: "可转债配对交易策略", content: "利用可转债之间的价差进行套利" },
        { key: "d55", label: "可转债套利策略", content: "利用可转债的期权、正股等衍生品进行套利" },
      ],
    },
    {
      key: "vip-fof",
      img: "vip-fof",
      colorGradient: "#B0E3FF",
      colorGradientActive: "#E5F6FF",
      label: "FOF策略",
      brief: "基金组合，分散风险",
      active: false,
      show: true,
      router: "class/vipFof",
      details: [
        { key: "d61", label: "稳健FOF策略", content: "采用稳健的投资策略，降低风险" },
        { key: "d62", label: "FOF风险评价策略", content: "对FOF组合进行风险评价，控制风险" },
        { key: "d63", label: "FOF动态再平衡策略", content: "根据市场情况对FOF组合进行动态调整" },
        { key: "d64", label: "FOF均值方差优化策略", content: "利用均值方差模型对FOF组合进行优化" },
        { key: "d65", label: "FOF事件驱动策略", content: "根据市场事件进行投资决策" },
      ],
    },
  ],
  vipCardsWait: [
    {
      key: "vip-ai",
      img: "vip-ai",
      colorGradient: "#C7DDFF",
      colorGradientActive: "#E6F0FF",
      label: "机器学习策略",
      brief: "科学预测，智能择时",
      active: false,
      show: false,
      router: "class/vipAi",
      details: [
        { key: "d71", label: "机器学习多空策略", content: "利用机器学习算法进行多空策略" },
        { key: "d72", label: "时间序列预测策略", content: "利用机器学习算法进行时间序列预测" },
        { key: "d73", label: "监督学习策略", content: "利用机器学习算法进行监督学习" },
        { key: "d74", label: "无监督学习策略", content: "利用机器学习算法进行无监督学习" },
        { key: "d75", label: "遗传算法策略", content: "利用遗传算法进行策略优化" },
      ],
    },
    {
      key: "vip-frequency",
      img: "vip-frequency",
      colorGradient: "#B0F4FF",
      colorGradientActive: "#E1FBFF",
      label: "高频策略",
      brief: "统计套利，事件驱动",
      active: false,
      show: false,
      router: "class/vipFrequency",
      details: [
        { key: "d81", label: "统计套利策略", content: "利用统计方法进行套利" },
        { key: "d82", label: "事件驱动策略", content: "利用市场事件进行交易" },
        { key: "d83", label: "对冲策略", content: "利用对冲策略降低风险" },
        { key: "d84", label: "跨市场套利策略", content: "利用跨市场价差进行套利" },
        { key: "d85", label: "跨期套利策略", content: "利用跨期价差进行套利" },
      ],
    },
  ],
  vipDetails: [
    { key: "vipDetail1", label: "股票策略一：股票策略股票策略，股票策略" },
    { key: "vipDetail2", label: "股票策略二：股票策略股票策略，股票策略股票策略股票" },
    { key: "vipDetail13", label: "股票策略三：股票策略股票策略，股票策略股票策略股票策略股票策略股票策略股票策略" },
    { key: "vipDetail4", label: "股票策略四：股票策略股票策略，股票策略股票策略" },
    { key: "vipDetail5", label: "股票策略五：股票策略股票策略，股票策略股票策略股票..." },
  ],
});
onBeforeMount(() => {
  let phoneFlag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (phoneFlag) {
    let paramP = router.currentRoute.value.query.p
    if (paramP) {
      router.push(`/wap/main?p=${paramP}`);
    } else {
      router.push(`/wap/main`);
    }
  } else {
    initBonus();
    model.showContent = true;
    // startTimer();
  }
});
onDeactivated(() => {
  endTimer();
});
//路由跳转
function routerClick(routerUrl) {
  router.push("/web/" + routerUrl);
}
// function startTimer() {
//   model.carouselTimer = window.setInterval(function () {
//     let index = model.activeCarouselIndex + 1;
//     if (index === 0) {
//       index = 0;
//     }
//     handleCarousel(model.carousels[index]);
//   }, 5000);
// }
function endTimer() {
  window.clearInterval(model.carouselTimer);
}
//轮播图点击
function handleCarousel(item) {
  endTimer();
  model.carousels[model.activeCarouselIndex].show = false;
  setTimeout(function () {
    model.activeCarouselIndex = item.index;
    model.carousels[model.activeCarouselIndex].show = true;
    // startTimer();
  }, 500);
}
//菜单hover
function menuHover(menu) {
  menu.active = true;
}
//菜单离开
function menuLeave(menu) {
  menu.active = false;
}

//奖学金初始化
function initBonus() {
  post("/classCatalog/getCatalogByUser", { classType: "27" }).then((res) => {
    if (res.success) {
      let bonusTopics = [];
      res.data.classCatalogVos.forEach((item) => {
        item.childCatalogs.forEach((child) => {
          bonusTopics.push({ key: child.catalogSn, topic: child.catalogName, label: item.catalogName, active: false });
        });
      });
      model.bonusTopics = bonusTopics;
    }
  });
}
//奖学金hover
function handleBonusHover(item) {
  item.active = true;
  if (model.bonusClearTask) {
    window.clearInterval(model.bonusClearTask);
  }
  model.bonusShowDetail.bonusInfo = item;
  model.bonusShowDetail.show = true;
  post("/classContent/listByUser", { catalogSn: item.key }).then((res) => {
    if (res.success) {
      model.bonusShowDetail.contents = res.data.classContentVos;
      nextTick(() => {
        Prism.highlightAll();
      });
    }
  });
}
//奖学金离开
function handleBounsLeave(item) {
  if (item) {
    item.active = false;
  }
  model.bonusClearTask = setTimeout(function () {
    model.bonusShowDetail.show = false;
  }, 1000);
}
//奖学金详情hover
function handleBonusDetail() {
  if (model.bonusClearTask) {
    window.clearInterval(model.bonusClearTask);
  }
}
//vip卡片 hover
function handleCardOver(card) {
  model.vipCards.forEach((item) => {
    if (item.key != card.key && item.active) {
      item.active = false;
      card.active = true;
    }
  });
}
//下一个vip
function handlePreviousVipCard() {
  //消失一张 重置状态
  let disapperCard = model.vipCards.splice(0, 1)[0];
  disapperCard.show = false;
  if (disapperCard.active) {
    model.vipCards[0].active = true;
    disapperCard.active = false;
  }
  model.vipCardsWait.push(disapperCard);
  //新增一张
  let showCard = model.vipCardsWait.splice(0, 1)[0];
  model.vipCards.push(showCard);
  setTimeout(function () {
    model.vipCards[5].show = true;
  }, 100);
}
//上一个vip
function handleNextVipCard() {
  //消失一张 重置状态
  let disapperCard = model.vipCards.splice(5, 1)[0];
  disapperCard.show = false;
  if (disapperCard.active) {
    model.vipCards[4].active = true;
    disapperCard.active = false;
  }
  model.vipCardsWait.unshift(disapperCard);
  //新增一张
  let showCard = model.vipCardsWait.splice(2, 1)[0];
  model.vipCards.unshift(showCard);
  setTimeout(function () {
    model.vipCards[0].show = true;
  }, 100);
}
//vip点击
function handleVipClick(card) {
  console.log(card);
  // router.push("/web/" + card.router);
}
</script>
<style lang="scss" scoped>
.banner-bar {
  height: 552px;
  width: 100%;
  position: relative;

  .carousel-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .carousel-bar {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 422px;
    width: calc(100% - 506px);
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: opacity 0.5s;

    img {
      height: 300px;
    }

    .carousel-content {
      .cc-title {
        font-size: 30px;
        font-weight: 500;
        margin-bottom: 24px;
      }

      .cc-brief {
        font-size: 18px;
        line-height: 36px;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .cc-content {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 90px;
      }

      .cc-btn {
        width: 192px;
        height: 44px;
        border-radius: 4px;
        background: #3379f1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

  .carousel-select {
    z-index: 10;
    position: absolute;
    bottom: 72px;
    right: 80px;
    display: flex;

    .carousel-select-btn {
      width: 48px;
      height: 4px;
      cursor: pointer;
      background: #fff;
    }
  }

  .menu-bar {
    top: 24px;
    left: 40px;
    right: 48px;
    position: absolute;
    border: 1px solid #53ceed;
    border-radius: 8px 24px 8px 24px;
    height: 48px;
    display: flex;
    justify-content: center;
    background: linear-gradient(180deg, #e9f6fc 0%, #dcf5ff 50%, #eaf7fc 100%);
    z-index: 19;

    .menu-btn {
      display: flex;
      height: 100%;
      align-items: center;
      margin-right: 3%;
      cursor: pointer;

      img {
        height: 20px;
        margin-right: 9px;
      }

      .menu-label {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  .bonus-bar {
    z-index: 10;
    position: absolute;
    top: 96px;
    left: 40px;
    width: 304px;
    height: 384px;
    background-color: #fff;
    box-shadow: 0px 0px 16px 0px rgba(17, 22, 41, 0.08);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .bonus-title {
      font-size: 28px;
      color: #3379f1;
      margin-top: 16px;
      width: 100%;
      text-align: center;

      img {
        width: 185px;
      }
    }

    .bonus-topic {
      border-radius: 8px;
      background: #f2f3f5;
      width: 256px;
      height: 32px;
      padding: 4px 12px;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      align-items: center;

      .topic-title {
        border-radius: 12px;
        border: 1px solid #3379f1;
        color: #3379f1;
        font-weight: 500;
        padding: 1px 8px;
        font-size: 12px;
        height: 20px;
        display: flex;
        align-items: center;
        margin-right: 16px;
      }
    }
  }

  .bonus-detail {
    z-index: 10;
    position: absolute;
    top: 96px;
    left: 356px;
    width: 304px;
    height: 384px;
    background-color: #fff;
    box-shadow: 0px 0px 16px 0px rgba(17, 22, 41, 0.08);
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    overflow: auto;

    .bd-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      color: #3379f1;

      .bd-topic {
        border-radius: 12px;
        border: 1px solid #3379f1;
        padding: 3px 0px 1px 8px;
        width: 45px;
        font-size: 12px;
      }

      .bd-label {
        margin-left: 8px;
        font-weight: 500;
        font-size: 14px;
      }
    }

    .bd-content {
      margin-bottom: 12px;

      .bdc-title {
        font-size: 12px;
        color: #999999;
        margin-bottom: 4px;
      }

      .bdc-contenc {
        font-size: 14px;
      }
    }
  }

  .data-bar {
    display: flex;
    justify-content: space-between;
    position: absolute;
    box-sizing: border-box;
    bottom: -40px;
    left: 0;
    width: 100%;
    padding: 0 40px;
    z-index: 19;

    .data-card {
      display: flex;
      width: 16%;
      height: 80px;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(17, 22, 41, 0.08);
      border-radius: 12px;
      padding: 10px 10px;
      box-sizing: border-box;
      position: relative;
      align-items: center;
      cursor: pointer;

      .data-card-mask {
        background: linear-gradient(180deg, rgba(218, 241, 250, 0.5) 0%, rgba(218, 241, 250, 0.1) 100%);
        position: absolute;
        left: 1px;
        top: 1px;
        right: 1px;
        bottom: 1px;
        border-radius: 12px;
      }

      img {
        width: 20%;
        max-width: 60px;
        z-index: 9;
      }

      .data-label {
        z-index: 9;
        font-weight: 500;
        flex: 1;
        text-align: center;
        font-size: 16px;

        &:hover {
          color: #3379f1;
        }
      }
    }
  }
}

.strategy-bar {
  padding: 100px 40px 60px;
  box-sizing: border-box;
  background-color: #f2f3f5;

  .strategy-title {
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .strategy-brief {
    text-align: center;
    font-size: 16px;
    color: #666666;
    margin-bottom: 28px;
  }

  .strategy-cards {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .strategy-card {
      width: 23%;
      background: #fff;
      margin-bottom: 28px;
      border-radius: 12px;
      padding: 4px;
      box-sizing: border-box;
      cursor: pointer;

      img {
        width: 100%;
        border-radius: 10px;
        margin-bottom: 12px;
      }

      .info-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 4px;

        .strategy-info {
          width: calc(100% - 90px);

          .info-title {
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 8px;
          }

          .info-brief {
            color: #666666;
            font-size: 12px;
            margin-bottom: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .strategy-btn {
          width: 80px;
          padding: 4px;
          text-align: center;
          box-sizing: border-box;
          background: #3379f1;
          border-radius: 4px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}

.vip-bar {
  padding-top: 48px;
  box-sizing: border-box;

  .vip-title {
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .vip-brief {
    text-align: center;
    font-size: 16px;
    color: #666666;
    margin-bottom: 28px;
  }

  .vip-cards {
    display: flex;
    justify-content: space-between;
    height: 430px;
    margin-bottom: 60px;
    cursor: pointer;

    .direction-cards {
      width: 90px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 32px;
        box-shadow: 0px 0px 16px 0px rgba(25, 29, 44, 0.06);
        background: linear-gradient(180deg, #f2f3f5 0%, rgba(242, 243, 245, 0.2) 100%);
        border-radius: 50%;
        cursor: pointer;
      }
    }

    .vip-card {
      height: 100%;
      width: 11%;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 16px;
      box-shadow: 0px 0px 16px 0px rgba(25, 29, 44, 0.2);
      transition: width 0.5s, opacity 0.3s;
      -webkit-transition: width 0.5s, opacity 0.3s;
      position: relative;
      display: flex;
      flex-direction: column;

      .vip-bg {
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        position: absolute;
        top: 2px;
        left: 2px;
        border-radius: 8px;
      }

      .vip-card-mask {
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        position: absolute;
        top: 2px;
        left: 2px;
        border-radius: 8px;
      }

      .vip-card-label {
        position: relative;
        font-size: 20px;
        margin-bottom: 16px;
        font-weight: 500;
        color: #fff;
        z-index: 9;
      }

      .vip-card-brief {
        position: relative;
        font-size: 14px;
        color: #fff;
        z-index: 9;
      }

      .vip-detail-bar {
        z-index: 9;
        position: relative;
        flex: 1;

        .vip-detail {
          display: flex;
          width: 100%;
          justify-content: space-between;
          margin-bottom: 12px;
          height: 15px;
          align-items: center;

          img {
            width: 12px;
            height: 12px;
          }

          .vip-detail-label {
            width: 93%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .vip-card-btn {
        position: relative;
        z-index: 9;
        width: 150px;
        background: #3379f1;
        color: #fff;
        text-align: center;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        cursor: pointer;
      }
    }

    .vip-card-active {
      width: calc(40% - 200px);

      .vip-card-label {
        color: #333333;
      }
    }
  }
}
</style>